// src/data/exercises/L6_07.js

// 1. Import trực tiếp các file ảnh từ thư mục assets
// TODO: Thay đổi tên file cho đúng với file ảnh của bạn
import GiaiThichDung from '../../assets/images/L6_07d.png';
import GoiYCoBan from '../../assets/images/L6_07s.png';
import GoiYChiTiet from '../../assets/images/L6_07d.png';

const accountOptions = [
  '現金', '資本金', '繰越利益剰余金', '売上原価', '損益'];

export const L6_07 = {
  title: '簿記　3級（第215-7回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
  parts: [
    { "type": "ruby", "text": "滋賀株式会社", "ruby": "しがかぶしきがいしゃ" },
    { "type": "text", "value": "は、" },
    { "type": "ruby", "text": "当期", "ruby": "とうき" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "決算", "ruby": "けっさん" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "結果", "ruby": "けっか" },
    { "type": "text", "value": "、" },
    { "type": "ruby", "text": "当期純利益", "ruby": "とうきじゅんりえき" },
    { "type": "text", "value": "￥987,000を" },
    { "type": "ruby", "text": "計上", "ruby": "けいじょう" },
    { "type": "text", "value": "した。" }
]
,
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '損益', debitAmount: 987000, creditAccount: '繰越利益剰余金', creditAmount: 987000},
      ],

      // 2. Gán trực tiếp biến đã import vào
      explanation_correct: GiaiThichDung,

      hints: {
        account: [
          // Gợi ý lần 1, 2
          GoiYCoBan,
          // Gợi ý lần 3 trở đi
          GoiYChiTiet,
        ],
      },
    },
  ],
};